import { ThemeCardImage } from "features/無料占いBot/components/ThemeCards/ThemeCardImage";
import sum from "lodash/sum";
import { FreeFortuneTheme } from "shared/models";

import { RadioGroupCard } from "../RadioGroupCard";

import { Genre } from "./ThemeCards";
import { FreeFortuneThemeDetailSchema } from "@miror/types";

interface Props {
  genres: Genre[];
  genre: Genre;
  themes: FreeFortuneTheme[] | FreeFortuneThemeDetailSchema[];
  index: number;
  className?: string;
}

export const ThemeCard = ({
  genres,
  genre,
  themes,
  index,
  className,
}: Props) => {
  const startIndex = sum(
    genres.map((_, genreIndex) =>
      genreIndex < index ? genres[genreIndex].chunk : 0
    )
  );
  const genreThemes = themes.slice(startIndex, startIndex + genre.chunk);
  const radios = genreThemes.map((data) => ({
    label: data.name,
    value: data.id,
  }));

  return (
    <RadioGroupCard
      renderImage={
        <ThemeCardImage image={genre.thumbnail} title={genre.name} />
      }
      text={`ご相談したいジャンルをお選びください。\n\n右にスクロールで他のジャンルも選ぶことができます。`}
      radioInputName="theme"
      radios={radios}
      className={className}
    />
  );
};
